export default "__VITE_ASSET__db3affad__"